export default {
  methods: {
    mapLayerElectricalHv25kvAdd() {
      this.initPollElectricalHv25kv();
      this.map.addSource("electrical-hv25kv-source", {
        type: "geojson",
        data: this.computedElectricalHv25kvGeoJson
      });

      this.map.addLayer({
        id: "electrical-hv25kv-fatfinger",
        type: "line",
        source: "electrical-hv25kv-source",
        paint: {
          "line-color": "Brown",
          "line-width": 20,
          "line-opacity": 0
        }
      });

      this.map.addLayer({
        id: "electrical-hv25kv",
        type: "line",
        source: "electrical-hv25kv-source",
        paint: {
          "line-color": "Red",
          "line-width": 2
        }
      });

      this.map.addLayer({
        id: "electrical-hv25kv-outline",
        type: "line",
        source: "electrical-hv25kv-source",
        paint: {
          "line-color": "darkred",
          "line-width": 8
        }
      });

      this.map.addLayer({
        id: "electrical-hv25kv-hover",
        type: "line",
        source: "electrical-hv25kv-source",
        paint: {
          "line-color": "Purple",
          "line-width": 12,
          "line-blur": 2
        }
      });

      this.map.moveLayer("electrical-hv25kv-hover", "marker-layer-lines");
      this.map.moveLayer("electrical-hv25kv-outline", "marker-layer-lines");
      this.map.moveLayer("electrical-hv25kv", "marker-layer-lines");
      this.map.moveLayer("electrical-hv25kv-fatfinger", "marker-layer-lines");
    },
    mapLayerElectricalHv25kvRemove() {
      this.cancelPollElectricalHv25kv();
      this.map.removeLayer("electrical-hv25kv-hover");
      this.map.removeLayer("electrical-hv25kv");
      this.map.removeLayer("electrical-hv25kv-outline");

      this.map.removeLayer("electrical-hv25kv-fatfinger");
      this.map.removeSource("electrical-hv25kv-source");
    },
    initPollElectricalHv25kv() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/electrical/hv25kv",
        dept: "electrical",
        layer: "hv25kv",
        token: this.computedAuthToken
      });
      this.pollElectricalHv25kvInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/electrical/hv25kv",
          dept: "electrical",
          layer: "hv25kv",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollElectricalHv25kv() {
      this.pollElectricalHv25kvInterval = clearInterval(
        this.pollElectricalHv25kvInterval
      );
    }
  },
  computed: {
    computedElectricalHv25kvGeoJson() {
      return this.$store.state.mapLayers.electrical.layers.hv25kv.geojson;
    },
    computedElectricalHv25kvMapVisibility() {
      return this.$store.state.mapLayers.electrical.layers.hv25kv.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.electrical.layers.hv25kv.geojson": {
      handler() {
        if (this.computedElectricalHv25kvGeoJson) {
          this.mapLayerElectricalHv25kvRemove();
          this.mapLayerElectricalHv25kvAdd();
        }
      }
    },
    "$store.state.mapLayers.electrical.layers.hv25kv.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerElectricalHv25kvAdd();
      } else {
        this.mapLayerElectricalHv25kvRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollElectricalHv25kv();
  }
};
